import {ShaderMaterial, Vector2, Vector4} from "three";
import commonShader from 'features/apartmentViewer/ApartmentViewer/shaders/layerShader.glsl';
import baseVertexShader from "features/apartmentViewer/ApartmentViewer/shaders/baseMaterial/baseMaterialVertex.glsl";
import baseFragmentShader
    from "features/apartmentViewer/ApartmentViewer/shaders/baseMaterial/baseMaterialFragment.glsl";

export class BaseMaterialFactory {
    public static createMaterial(width: number, height: number, layerCount: number): ShaderMaterial {
        return new ShaderMaterial({
            uniforms: {
                // Textures for the current and next panorama layers
                panoramaCurrent: { value: null },
                panoramaNext: { value: null },
                motionFlow: { value: null },

                // Textures for the layer panorama spheres
                layerPanoramaSphereCurrent: { value: null },
                layerPanoramaSphereNext: { value: null },

                // Transition state and alpha blending parameters
                u_isPanoramaTransition: { value: false },
                u_panoramaCurrentAlpha: { value: 0 },
                u_panoramaNextAlpha: { value: 0 },
                u_transitionPercentage: { value: 0 },

                // Rotation and field of view settings
                u_rotation: { value: new Vector2(0, 0) },
                u_fovy: { value: 90 },
                u_aspectratio: { value: width / height },

                // Layer textures and metadata
                layerTextures: { value: [] },

                // Shaders does not have dynamic array support, so we need to pass the layer info as a vector4 array
                layerInfo: {
                    value: [
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                    ]
                },
                layerCount: { value: layerCount },

                // Time uniform for animation or other time-based effects
                time: { value: 0 }
            },
            vertexShader: baseVertexShader,
            fragmentShader: `${commonShader}${baseFragmentShader}`
        });
    }
}
